import { RefinementCtx, ZodError } from 'zod'

export const resolveJSONParse = (value: unknown, ctx: RefinementCtx) => {
  if (typeof value === 'string')
    try {
      return JSON.parse(value)
    } catch (err) {
      const stringError =
        typeof err === 'string'
          ? err
          : err instanceof Error
            ? err.message
            : 'Weird error. Check console.'
      console.error(err)
      ctx.addIssue({ code: 'custom', message: stringError })
    }

  return value
}

export const getZodErrorMessage = (error: ZodError) => {
  const first = error.issues[0]
  return first
    ? `${first.message} - path: ${first.path.filter((el) => !Number.isInteger(el)).join('.')}`
    : null
}
